import { Options } from "react-use-websocket";

export const SocketState = new Map<number, string>([
  [-1, "DISCONNECTED"],
  [0, "CONNECTING"],
  [1, "CONNECTED"],
  [2, "CLOSING"],
  [3, "CLOSED"],
]);

const socketLogStyle = (color: string, background: string) =>
  `color: ${color}; background: ${background}; padding: 2px 30px; border-radius: 4px; font-weight: bold;`;

const SOCKET_LOG = {
  open: socketLogStyle("#166534", "#D1FAE5"),
  closing: socketLogStyle("#9A3412", "#FFEDD5"),
  closed: socketLogStyle("#991B1B", "#FEE2E2"),
};

export const SocketConfig: Options = {
  onOpen: () =>
    console.log(
      `%c[${new Date().toLocaleTimeString()}] WS: Connection established`,
      SOCKET_LOG.open
    ),
  shouldReconnect: (closeEvent) => true,
  reconnectInterval: 5000,
  reconnectAttempts: 9,
  retryOnError: true,
  onError: (err: any) => {
    console.log(
      `%c[${new Date().toLocaleTimeString()}] WS Event: onError err`,
      SOCKET_LOG.closed,
      err
    );
  },
  onClose: (event) => {
    console.log(
      `%c[${new Date().toLocaleTimeString()}] WS Event: Close event`,
      SOCKET_LOG.closed,
      event
    );
  },
  onReconnectStop: (attemps) => {
    console.log(
      `%c[${new Date().toLocaleTimeString()}] WS Event: onReconnectStop attemps`,
      SOCKET_LOG.closing,
      attemps
    );
    window.location.reload();
  },
  // Debe coincidir EXACTO con setWebSocketAutoResponse('{ping}', '{pong}') del DO
  // para que el runtime responda sin despertar la hibernación.
  heartbeat: {
    message: "{ping}",
    returnMessage: "{pong}",
    interval: 25000,
    timeout: 60000,
  },
};
